import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function usePromoCodes() {
  const [validating, setValidating] = useState(false);

  const validate = async (code: string) => {
    setValidating(true);
    const { data, error } = await supabase
      .from("promo_codes")
      .select("*")
      .eq("code", code.toUpperCase())
      .eq("is_active", true)
      .maybeSingle();
    setValidating(false);

    if (error || !data) return { valid: false, error: "Code not found or inactive" };
    if (data.valid_until && new Date(data.valid_until) < new Date()) return { valid: false, error: "Code expired" };
    if (data.max_uses && data.used_count >= data.max_uses) return { valid: false, error: "Code fully redeemed" };
    return { valid: true, promo: data };
  };

  return { validate, validating };
}
